<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="acknow">
<p class="ct"><a class="xref" href="#/pppcondispos005#toc">Acknowledgments</a></p>
<p class="pf">The author would like to extend special thanks to Vincent Mares, Jeff Encinias, Leslie Fernandez, and Kathy Trujillo.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppcondispos006.vue?3d1f0010